import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, BehaviorSubject } from 'rxjs';
import { ResponseErrorModel } from '../models/response-error.model';
import { AlertService } from './alert.service';
import { BaseResolverModel } from '../models/baseResolver.model';

export class ResponseErrorHandler {
    constructor(private router: Router,
                private alertService: AlertService,
                private componentName: string = null) {
    }

    get error(): Observable<ResponseErrorModel> {
        return this.subject.asObservable();
    }

    private subject = new BehaviorSubject<ResponseErrorModel>(null);

    reset() {
        this.subject.next(null);
        this.alertService.clear();
    }

    displayFormNotValidMessage() {
        this.displayMessage('Please enter all required fields.');
    }

    displayPleaseWaitMessage() {
        this.displayMessage('Please wait...');
    }

    displayMessage(errorMessage: string) {
        const model = new ResponseErrorModel(errorMessage);
        model.setPrimary();
        this.subject.next(model);
    }

    displaySuccessMessage(errorMessage: string) {
        const model = new ResponseErrorModel(errorMessage);
        model.setSuccess();
        this.subject.next(model);
    }

    displayErrorMessage(errorMessage: string) {
        const model = new ResponseErrorModel(errorMessage);
        model.setDanger();
        this.subject.next(model);
    }

    checkAndHandleErrors(errorData: BaseResolverModel) {
        if (errorData.httpError != null) {
            this.handle(errorData.httpError, 'Could not get server data');
        } else if (errorData.errorMessage != null) {
            this.displayErrorMessage(errorData.errorMessage);
        }
    }

    log(message: string) {
        if ( this.componentName != null ) {
            message = this.componentName + ': ' + message;
        }
        this.alertService.information(message);
    }

    handle(errorResponse: any, errorMessage: string, keysAsLabelsMap: Map<string, string> = null) {

        const errorData = errorResponse.error;
        const statusCode = errorResponse.status;

        let message = errorMessage;

        if ( this.componentName != null ) {
            message = this.componentName + ': ' + message;
        }
        console.log({ e: 'ErrorHandler::handle()', data: errorData, status: statusCode, message });

        if (statusCode === 401) {
            message += '<br/><strong>401: Not Logged In</strong>';
        } else if (statusCode === 403) {
            message += '<br/><strong>403: Not authorized.</strong>';
        } else if (statusCode === 404) {
            message += '<br/><strong>404: Not found.</strong>';
        } else if (statusCode === 500) {
            message += '<br/><strong>Internal 500 Error</strong>';
            if ( errorData?.stackTrace !== undefined ) {
                message += '<br/>' + errorData.stackTrace;
            }
            if ( errorData?.message !== undefined ) {
                message += '<br/>' + errorData.message;
            }
        }

        console.log(message);
        let model = new ResponseErrorModel(message);

        if ((statusCode === 400) && (errorData instanceof Object) && (errorData.modelState !== undefined)) {
            model.setModelState(errorData.modelState, keysAsLabelsMap);
        } else if ((statusCode === 400) && (errorData instanceof Object) && (errorData.errors !== undefined)) {
            model.setModelState(errorData.errors, keysAsLabelsMap);
        } else if ((statusCode === 400) && (errorData instanceof Object) && (errorData.violations !== undefined)) {
            model.setModelState(errorData.violations, keysAsLabelsMap);
        } else {
            model = new ResponseErrorModel(message);
        }

        console.log(model);
        model.setDanger();
        this.subject.next(model);

        this.alertService.error(message);

        if (statusCode === 401) {
            this.router.navigate(['/welcome']);
        }
    }
}
